"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelHelpUrl = void 0;
const tslib_1 = require("tslib");
const catalog_help_url_1 = require("@tableau/catalog-help-url");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
function LabelHelpUrl(props) {
    const href = (0, catalog_help_url_1.useServerHelpUrlByToken)({ helpToken: tokens[props.dialogType] });
    return (react_1.default.createElement(widgets_1.TextLinkWidget, { href: href, testId: '-label-dialog-help', target: '_blank', rel: 'noopener noreferrer' }, catalog_messages_1.Messages.LearnMoreLink()));
}
exports.LabelHelpUrl = LabelHelpUrl;
const tokens = Object.freeze({
    'certification': 'label-certification',
    'sensitivity': 'label-sensitivity',
    'EXTRACT_REFRESH_FAILURE': 'dqw-auto-extract',
    'FLOW_RUN_FAILURE': 'dqw-auto-flow',
    'warning': 'dqw-manual',
});
//# sourceMappingURL=LabelHelpUrl.js.map